import React, { useState, useEffect } from "react";
import { PDFDocument } from "pdf-lib";
import { connect } from 'react-redux'
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import moment from 'moment';
import { isEmpty, isUndefined, filter, isNumber } from 'lodash';
import FL142Section from '../../disclosure/fl-142/FL142Section';
import FL142SecondSection from '../fl-142/FL142SecondSection';
import { postData, successDescriptionOptionData, postSecondTableData, getData } from '../fl-142/FL142.actions';
import Loader from "react-loader-spinner";
import { serverApi } from '../../../../../global/globalFunctions';
import {
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Collapse,
  CustomInput,
  Card,
  ModalBody,
  Modal,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { getStates, getFormData as getProfileFormData } from "../../profileInformation/profileInformation.actions";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}));


const FL142 = (props) => {


  function getSteps() {
    return [
      "REAL ESTATE",
      "HOUSEHOLD FURNITURE,FURNISHINGS,APPLIANCES",
      "JEWELRY, ANTIQUE, ART, COIN COLLECTIONS, etc.",
      "VEHICLES, BOATS, TRAILERS",
      "SAVINGS ACCOUNTS",
      "CHECKING ACCOUNTS",
      "CREDIT UNION,OTHER DEPOSITORY ACCOUNTS",
      "CASH",
      "TAX REFUND",
      "LIFE INSURANCE WITH CASH SURRENDER OR LOAN VALUE",
      "STOCKS,BONDS,SECURED NOTES, MUTUAL FUNDS",
      "RETIREMENTS AND PENSIONS",
      "PROFIT-SHARING,IRAS, DEFERRED COMPENSATION, ANNUITIES",
      "ACCOUNTS RECEIVEABLE,UNSECURED NOTES",
      "PARTNERSHIP, OTHER BUSINESS INTERESTS",
      "OTHER ASSESTS",
      "STUDENT LOANS",
      "TAXES",
      "SUPPORT ARREARAGES",
      "LOANS-UNSECURED",
      "CREDIT CARDS",
      "OTHER DEBTS",
    ];

  }


  async function myFunction() {
    const existingPdfBytes = await fetch(`${serverApi}/FL-142`, {
      headers: {
        Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
      },
    }).then((res) => res.arrayBuffer());
    var bytes = new Uint8Array(existingPdfBytes);
    const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true });
    const form = pdfDoc.getForm();


    const petitionerDetails = props.petitioner;
    const respondentDetails = props.respondent;
    const courtDetails = props.court;
    console.log(petitionerDetails,"petitionerDetails")
    let totalFairValue = 0;
    let totalMoneyOwned = 0;

    let totalOwing = 0;




    const petState = !isUndefined(petitionerDetails) && filter(props.states, state => state.state_id == petitionerDetails.state);
    const resState = !isUndefined(respondentDetails) && filter(props.states, state => state.state_id == respondentDetails.state);
    const courtState = !isUndefined(courtDetails) && filter(props.states, state => state.state_id == courtDetails.branch);



    !isUndefined(courtDetails) && form.getField("superior").setText(courtDetails.county);

    !isUndefined(respondentDetails) && form.getField("respondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
    !isUndefined(petitionerDetails) && form.getField("petitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);


    if (props.petitionerCheck == "0") {
      !isUndefined(petitionerDetails) && form.getField("nameP").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
      !isUndefined(petitionerDetails) && form.getField("telephone").setText(petitionerDetails.telephone);
      form.getCheckBox("ch_p").check();
      !isUndefined(petitionerDetails) && form.getField("name").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}` + `\n` + `${petitionerDetails.streetAddress}` + `\n` + `${petitionerDetails.city}` + `,` + `${petState[0].state_name}` + ` ` + `${petitionerDetails.zip}`);

    } else {
      !isUndefined(respondentDetails) && form.getField("nameP").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
      !isUndefined(respondentDetails) && form.getField("telephone").setText(respondentDetails.telephone);
      form.getCheckBox("ch_r").check();
      !isUndefined(respondentDetails) && form.getField("name").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}` + `\n` + `${respondentDetails.streetAddress}` + `\n` + `${respondentDetails.city}` + `,` + `${resState[0].state_name}` + ` ` + `${respondentDetails.zip}`);

    }


    form.getField("caseNumber").setText(courtDetails.caseNumber.toString());
    //REALSTATE
    props.realEstate.map((value, index) => {
      console.log(value,"testttttttttttaaabbcccddd")

      totalFairValue = Number(totalFairValue) + Number(value.asset_cgfmv);
      totalMoneyOwned = Number(totalMoneyOwned) + Number(value.asset_amoe);

      form.getField(`RED${index}`).setText(value.asset_description);
      !isUndefined(value.asset_sep_prop) && value.asset_sep_prop == "1" && form.getField(`RESP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.asset_date_acquired) && !isEmpty(value.asset_date_acquired) && form.getField(`REDA${index}`).setText(value.asset_date_acquired == "1947-01-01" ? "" : moment(value.asset_date_acquired).format('l'));
      !isUndefined(value.asset_cgfmv) && form.getField(`REGF${index}`).setText(value.asset_cgfmv.toString());
      !isUndefined(value.asset_amoe) && form.getField(`REAM${index}`).setText(value.asset_amoe.toString());
    });

    // //HOUSEHOLD
    props.household.map((value, index) => {

      totalFairValue = Number(totalFairValue) + Number(value.asset_cgfmv);
      totalMoneyOwned = Number(totalMoneyOwned) + Number(value.asset_amoe);

      form.getField(`HOD${index}`).setText(value.asset_description);
      !isUndefined(value.asset_sep_prop) && value.asset_sep_prop == "1" && form.getField(`HOSP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.asset_date_acquired) && !isEmpty(value.asset_date_acquired) && form.getField(`HODA${index}`).setText(value.asset_date_acquired == "1947-01-01" ? "" : moment(value.asset_date_acquired).format('l'));
      !isUndefined(value.asset_cgfmv) && form.getField(`HOGF${index}`).setText(value.asset_cgfmv.toString());
      !isUndefined(value.asset_amoe) && form.getField(`HOAM${index}`).setText(value.asset_amoe.toString());
    });

    //JEWELARY  
    props.jewelary.map((value, index) => {

      totalFairValue = Number(totalFairValue) + Number(value.asset_cgfmv);
      totalMoneyOwned = Number(totalMoneyOwned) + Number(value.asset_amoe);

      form.getField(`JED${index}`).setText(value.asset_description);
      !isUndefined(value.asset_sep_prop) && value.asset_sep_prop == "1" && form.getField(`JESP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.asset_date_acquired) && !isEmpty(value.asset_date_acquired) && form.getField(`JEDA${index}`).setText(value.asset_date_acquired == "1947-01-01" ? "" : moment(value.asset_date_acquired).format('l'));
      !isUndefined(value.asset_cgfmv)  && form.getField(`JEGF${index}`).setText(value.asset_cgfmv.toString());
      !isUndefined(value.asset_amoe) && form.getField(`JEAM${index}`).setText(value.asset_amoe.toString());
    });

    //VEHICLES
    props.vehicles.map((value, index) => {

      if (index === 8 ) {
        totalFairValue = Number(totalFairValue) + Number(value.asset_cgfmv);
        totalMoneyOwned = Number(totalMoneyOwned) + Number(value.asset_amoe);

        form.getField(`VED${index}`).setText(value.asset_description);
        !isUndefined(value.asset_sep_prop) && value.asset_sep_prop == "1" && form.getField(`VESP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
        !isUndefined(value.asset_date_acquired) && !isEmpty(value.asset_date_acquired) && form.getField(`VEDA.${index}`).setText(value.asset_date_acquired == "1947-01-01" ? "" : moment(value.asset_date_acquired).format('l'));
        !isUndefined(value.asset_cgfmv)  && form.getField(`VEGF${index}`).setText(value.asset_cgfmv.toString());
        !isUndefined(value.asset_amoe) && form.getField(`VEAM${index}`).setText(value.asset_amoe.toString());
      } else {
        totalFairValue = Number(totalFairValue) + Number(value.asset_cgfmv);
        totalMoneyOwned = Number(totalMoneyOwned) + Number(value.asset_amoe);
  
        form.getField(`VED${index}`).setText(value.asset_description);
        !isUndefined(value.asset_sep_prop) && value.asset_sep_prop == "1" && form.getField(`VESP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
        !isUndefined(value.asset_date_acquired) && !isEmpty(value.asset_date_acquired) && form.getField(`VEDA${index}`).setText(value.asset_date_acquired == "1947-01-01" ? "" : moment(value.asset_date_acquired).format('l'));
        !isUndefined(value.asset_cgfmv)  && form.getField(`VEGF${index}`).setText(value.asset_cgfmv.toString());
        !isUndefined(value.asset_amoe) && form.getField(`VEAM${index}`).setText(value.asset_amoe.toString());
      }

    });

    //savings          
    props.savings.map((value, index) => {

      totalFairValue = Number(totalFairValue) + Number(value.asset_cgfmv);
      totalMoneyOwned = Number(totalMoneyOwned) + Number(value.asset_amoe);

      form.getField(`SAD${index}`).setText(value.asset_description);
      !isUndefined(value.asset_sep_prop) && value.asset_sep_prop == "1" && form.getField(`SASP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.asset_date_acquired) && !isEmpty(value.asset_date_acquired) && form.getField(`SADA${index}`).setText(value.asset_date_acquired == "1947-01-01" ? "" : moment(value.asset_date_acquired).format('l'));
      !isUndefined(value.asset_cgfmv)  && form.getField(`SAGF${index}`).setText(value.asset_cgfmv.toString());
      !isUndefined(value.asset_amoe) && form.getField(`SAAM${index}`).setText(value.asset_amoe.toString());
    });

    //CHECKING_ACCOUNT
    props.checking.map((value, index) => {

      totalFairValue = Number(totalFairValue) + Number(value.asset_cgfmv);
      totalMoneyOwned = Number(totalMoneyOwned) + Number(value.asset_amoe);

      form.getField(`CHD${index}`).setText(value.asset_description);
      !isUndefined(value.asset_sep_prop) && value.asset_sep_prop == "1" && form.getField(`CHSP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.asset_date_acquired) && !isEmpty(value.asset_date_acquired) && form.getField(`CHDA${index}`).setText(value.asset_date_acquired == "1947-01-01" ? "" : moment(value.asset_date_acquired).format('l'));
      !isUndefined(value.asset_cgfmv)  && form.getField(`CHGF${index}`).setText(value.asset_cgfmv.toString());
      !isUndefined(value.asset_amoe) && form.getField(`CHAM${index}`).setText(value.asset_amoe.toString());
    });

    //CREDIT_UNION
    props.credit.map((value, index) => {

      totalFairValue = Number(totalFairValue) + Number(value.asset_cgfmv);
      totalMoneyOwned = Number(totalMoneyOwned) + Number(value.asset_amoe);

      form.getField(`CRD${index}`).setText(value.asset_description);
      !isUndefined(value.asset_sep_prop) && value.asset_sep_prop == "1" && form.getField(`CRSP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.asset_date_acquired) && !isEmpty(value.asset_date_acquired) && form.getField(`CRDA${index}`).setText(value.asset_date_acquired == "1947-01-01" ? "" : moment(value.asset_date_acquired).format('l'));
      !isUndefined(value.asset_cgfmv)  && form.getField(`CRGF${index}`).setText(value.asset_cgfmv.toString());
      !isUndefined(value.asset_amoe) && form.getField(`CRAM${index}`).setText(value.asset_amoe.toString());
    });

    //CASH
    props.cash.map((value, index) => {

      totalFairValue = Number(totalFairValue) + Number(value.asset_cgfmv);
      totalMoneyOwned = Number(totalMoneyOwned) + Number(value.asset_amoe);

      form.getField(`CAD${index}`).setText(value.asset_description);
      !isUndefined(value.asset_sep_prop) && value.asset_sep_prop == "1" && form.getField(`CASP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.asset_date_acquired) && !isEmpty(value.asset_date_acquired) && form.getField(`CADA${index}`).setText(value.asset_date_acquired == "1947-01-01" ? "" : moment(value.asset_date_acquired).format('l'));
      !isUndefined(value.asset_cgfmv)  && form.getField(`CAGF${index}`).setText(value.asset_cgfmv.toString());
      !isUndefined(value.asset_amoe) && form.getField(`CAAM${index}`).setText(value.asset_amoe.toString());
    });

    //TAxREFUND
    props.taxRefund.map((value, index) => {

      totalFairValue = Number(totalFairValue) + Number(value.asset_cgfmv);
      totalMoneyOwned = Number(totalMoneyOwned) + Number(value.asset_amoe);

      form.getField(`TAD${index}`).setText(value.asset_description);
      !isUndefined(value.asset_sep_prop) && value.asset_sep_prop == "1" && form.getField(`TASP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.asset_date_acquired) && !isEmpty(value.asset_date_acquired) && form.getField(`TADA${index}`).setText(value.asset_date_acquired == "1947-01-01" ? "" : moment(value.asset_date_acquired).format('l'));
      !isUndefined(value.asset_cgfmv)  && form.getField(`TAGF${index}`).setText(value.asset_cgfmv.toString());
      !isUndefined(value.asset_amoe) && form.getField(`TAAM${index}`).setText(value.asset_amoe.toString());
    });


    //INSUNRACNE
    props.lifeInsurance.map((value, index) => {

      totalFairValue = Number(totalFairValue) + Number(value.asset_cgfmv);
      totalMoneyOwned = Number(totalMoneyOwned) + Number(value.asset_amoe);

      form.getField(`LID${index}`).setText(value.asset_description);
      !isUndefined(value.asset_sep_prop) && value.asset_sep_prop == "1" && form.getField(`LISP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.asset_date_acquired) && !isEmpty(value.asset_date_acquired) && form.getField(`LIDA${index}`).setText(value.asset_date_acquired == "1947-01-01" ? "" : moment(value.asset_date_acquired).format('l'));
      !isUndefined(value.asset_cgfmv)  && form.getField(`LIGF${index}`).setText(value.asset_cgfmv.toString());
      !isUndefined(value.asset_amoe) && form.getField(`LIAM${index}`).setText(value.asset_amoe.toString());
    });
    //STOCKS
    props.stocks.map((value, index) => {

      totalFairValue = Number(totalFairValue) + Number(value.asset_cgfmv);
      totalMoneyOwned = Number(totalMoneyOwned) + Number(value.asset_amoe);

      form.getField(`STD${index}`).setText(value.asset_description);
      !isUndefined(value.asset_sep_prop) && value.asset_sep_prop == "1" && form.getField(`STSP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.asset_date_acquired) && !isEmpty(value.asset_date_acquired) && form.getField(`STDA${index}`).setText(value.asset_date_acquired == "1947-01-01" ? "" : moment(value.asset_date_acquired).format('l'));
      !isUndefined(value.asset_cgfmv)  && form.getField(`STGF${index}`).setText(value.asset_cgfmv.toString());
      !isUndefined(value.asset_amoe) && form.getField(`STAM${index}`).setText(value.asset_amoe.toString());
    });

    //RETIREMENT
    props.retirements.map((value, index) => {

      totalFairValue = Number(totalFairValue) + Number(value.asset_cgfmv);
      totalMoneyOwned = Number(totalMoneyOwned) + Number(value.asset_amoe);

      form.getField(`RETD${index}`).setText(value.asset_description);
      !isUndefined(value.asset_sep_prop) && value.asset_sep_prop == "1" && form.getField(`RETSP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.asset_date_acquired) && !isEmpty(value.asset_date_acquired) && form.getField(`RETDA${index}`).setText(value.asset_date_acquired == "1947-01-01" ? "" : moment(value.asset_date_acquired).format('l'));
      !isUndefined(value.asset_cgfmv)  && form.getField(`RETGF${index}`).setText(value.asset_cgfmv.toString());
      !isUndefined(value.asset_amoe) && form.getField(`RETAM${index}`).setText(value.asset_amoe.toString());
    });

    //PROFIT-SHARING
    props.profit.map((value, index) => {

      totalFairValue = Number(totalFairValue) + Number(value.asset_cgfmv);
      totalMoneyOwned = Number(totalMoneyOwned) + Number(value.asset_amoe);

      form.getField(`PRD${index}`).setText(value.asset_description);
      !isUndefined(value.asset_sep_prop) && value.asset_sep_prop == "1" && form.getField(`PRSP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.asset_date_acquired) && !isEmpty(value.asset_date_acquired) && form.getField(`PRDA${index}`).setText(value.asset_date_acquired == "1947-01-01" ? "" : moment(value.asset_date_acquired).format('l'));
      !isUndefined(value.asset_cgfmv)  && form.getField(`PRGF${index}`).setText(value.asset_cgfmv.toString());
      !isUndefined(value.asset_amoe) && form.getField(`PRAM${index}`).setText(value.asset_amoe.toString());
    });


    //ACCOUNTS RECEIVEABLE

    props.accounts.map((value, index) => {

      totalFairValue = Number(totalFairValue) + Number(value.asset_cgfmv);
      totalMoneyOwned = Number(totalMoneyOwned) + Number(value.asset_amoe);

      form.getField(`ACD${index}`).setText(value.asset_description);
      !isUndefined(value.asset_sep_prop) && value.asset_sep_prop == "1" && form.getField(`ACSP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.asset_date_acquired) && !isEmpty(value.asset_date_acquired) && form.getField(`ACDA${index}`).setText(value.asset_date_acquired == "1947-01-01" ? "" : moment(value.asset_date_acquired).format('l'));
      !isUndefined(value.asset_cgfmv)  && form.getField(`ACGF${index}`).setText(value.asset_cgfmv.toString());
      !isUndefined(value.asset_amoe) && form.getField(`ACAM${index}`).setText(value.asset_amoe.toString());
    });

    //partnership               
    props.partnership.map((value, index) => {

      totalFairValue = Number(totalFairValue) + Number(value.asset_cgfmv);
      totalMoneyOwned = Number(totalMoneyOwned) + Number(value.asset_amoe);

      form.getField(`PAD${index}`).setText(value.asset_description);
      !isUndefined(value.asset_sep_prop) && value.asset_sep_prop == "1" && form.getField(`PASP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.asset_date_acquired) && !isEmpty(value.asset_date_acquired) && form.getField(`PADA${index}`).setText(value.asset_date_acquired == "1947-01-01" ? "" : moment(value.asset_date_acquired).format('l'));
      !isUndefined(value.asset_cgfmv)  && form.getField(`PAGF${index}`).setText(value.asset_cgfmv.toString());
      !isUndefined(value.asset_amoe) && form.getField(`PAAM${index}`).setText(value.asset_amoe.toString());
    });


    //OTHER ASSET

    props.otherAssets.map((value, index) => {

      totalFairValue = Number(totalFairValue) + Number(value.asset_cgfmv);
      totalMoneyOwned = Number(totalMoneyOwned) + Number(value.asset_amoe);

      form.getField(`OTHD${index}`).setText(value.asset_description);
      !isUndefined(value.asset_sep_prop) && value.asset_sep_prop == "1" && form.getField(`OTHSP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.asset_date_acquired) && !isEmpty(value.asset_date_acquired) && form.getField(`OTHDA${index}`).setText(value.asset_date_acquired == "1947-01-01" ? "" : moment(value.asset_date_acquired).format('l'));
      !isUndefined(value.asset_cgfmv)  && form.getField(`OTHGF${index}`).setText(value.asset_cgfmv.toString());
      !isUndefined(value.asset_amoe) && form.getField(`OTHAM${index}`).setText(value.asset_amoe.toString());
    });

   //TOTAL ASSETS

    form.getField(`TOTGF`).setText(totalFairValue.toString());
    form.getField(`TOTAM`).setText(totalMoneyOwned.toString());



    //STUDENT LOANS
    props.studentLoans.map((value, index) => {

      totalOwing = Number(totalOwing) + Number(value.total_owing);

      form.getField(`STUD${index}`).setText(value.debt_description);
      !isUndefined(value.debt_date_incurred) && !isEmpty(value.debt_date_incurred) && form.getField(`STUDI${index}`).setText(value.debt_date_incurred == "1947-01-01" ? "" : moment(value.debt_date_incurred).format('l'));
      !isUndefined(value.debt_sep_prop) && value.debt_sep_prop == "1" && form.getField(`STUSP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.total_owing) && form.getField(`STUTO${index}`).setText(value.total_owing.toString());
    });

    //TAX

    props.taxes.map((value, index) => {

      totalOwing = Number(totalOwing) + Number(value.total_owing);

      form.getField(`TAXD${index}`).setText(value.debt_description);
      !isUndefined(value.debt_date_incurred) && !isEmpty(value.debt_date_incurred) && form.getField(`TAXDI${index}`).setText(value.debt_date_incurred == "1947-01-01" ? "" : moment(value.debt_date_incurred).format('l'));
      !isUndefined(value.debt_sep_prop) && value.debt_sep_prop == "1" && form.getField(`TAXSP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.total_owing) && form.getField(`TAXTO${index}`).setText(value.total_owing.toString());
    });

    //support

    props.support.map((value, index) => {

      totalOwing = Number(totalOwing) + Number(value.total_owing);
      form.getField(`SUD${index}`).setText(value.debt_description);
      !isUndefined(value.debt_date_incurred) && !isEmpty(value.debt_date_incurred) && form.getField(`SUDI${index}`).setText(value.debt_date_incurred == "1947-01-01" ? "" : moment(value.debt_date_incurred).format('l'));
      !isUndefined(value.debt_sep_prop) && value.debt_sep_prop == "1" && form.getField(`SUSP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.total_owing) && form.getField(`SUTO${index}`).setText(value.total_owing.toString());
    });



    //loans

    props.loans.map((value, index) => {
      totalOwing = Number(totalOwing) + Number(value.total_owing);
      form.getField(`LOD${index}`).setText(value.debt_description);
      !isUndefined(value.debt_date_incurred) && !isEmpty(value.debt_date_incurred) && form.getField(`LODI${index}`).setText(value.debt_date_incurred == "1947-01-01" ? "" : moment(value.debt_date_incurred).format('l'));
      !isUndefined(value.debt_sep_prop) && value.debt_sep_prop == "1" && form.getField(`LOSP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.total_owing) && form.getField(`LOTO${index}`).setText(value.total_owing.toString());
    });

    //creditCards

    props.creditCards.map((value, index) => {
      totalOwing = Number(totalOwing) + Number(value.total_owing);
      index == 5 ? form.getField(`CRD${index}`).setText(value.debt_description): form.getField(`CRED${index}`).setText(value.debt_description);
      !isUndefined(value.debt_date_incurred) && !isEmpty(value.debt_date_incurred) && form.getField(`CREDI${index}`).setText(value.debt_date_incurred == "1947-01-01" ? "" : moment(value.debt_date_incurred).format('l'));
      !isUndefined(value.debt_sep_prop) && value.debt_sep_prop == "1" && form.getField(`CRESP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.total_owing) && form.getField(`CRETO${index}`).setText(value.total_owing.toString());
    });

    //debts

    props.debts.map((value, index) => {
      totalOwing = Number(totalOwing) + Number(value.total_owing);
      form.getField(`OTD${index}`).setText(value.debt_description);
      !isUndefined(value.debt_date_incurred) && !isEmpty(value.debt_date_incurred) && form.getField(`OTDI${index}`).setText(value.debt_date_incurred == "1947-01-01" ? "" : moment(value.debt_date_incurred).format('l'));
      !isUndefined(value.debt_sep_prop) && value.debt_sep_prop == "1" && form.getField(`OTSP${index}`).setText(props.petitionerCheck == "0" ? "P" : "R");
      !isUndefined(value.total_owing) && form.getField(`OTTO${index}`).setText(value.total_owing.toString());
    });


    form.getField(`TOTTO`).setText(totalOwing.toString());



    // form.flatten();
    const pdfBytes = await pdfDoc.save();
    const pdfDataUrl = URL.createObjectURL(
      new Blob([pdfBytes], { type: "application/pdf" })
    );
    window.open(pdfDataUrl, "_blank");
  }
  // async function myFunction() {
  //   const existingPdfBytes = await fetch(`${serverApi}/FL-142`, {
  //     method:'GET',
  //     credentials: "include",
  //     headers: {
  //       Authorization: 'BEARER ' + window.localStorage.getItem("auth_id"),
  //     },
  //   }).then((res) => {
  //   if (res.status === 200) {
  //     return res.arrayBuffer();
  //   }
  //   throw new Error('Something went wrong');
  //   }
  // )
  // .then((responseJson) => {
  //   console.log("test11223344")
  // })
  // .catch((error) => {
  //   console.log(error,"errorrrrrrrrrr")
  // });
  // }


  function saveByteArray(reportName, byte) {
    var blob = new Blob([byte], { type: "application/pdf" });
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    var fileName = reportName;
    link.download = fileName;
    link.click();
  }


  const classes = useStyles();

  useEffect(() => {
    props.getProfileFormData({ divorce_id: window.localStorage.getItem("divorce_id") });
    props.getStates();
    props.successDescriptionOptionData();
    props.getData({ divorce_id: Number(window.localStorage.getItem("divorce_id")) });
    handleShow();

  }, []);

  const [data, setData] = useState('');
  const [descriptionID, setDescriptionID] = useState('');
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);


  function getStepContent(step, props) {
    switch (step) {

      case 0:
        return <FL142Section
          data={props.realEstate}
          descriptionId={1}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[0].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[0].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[0].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[0].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[0].asset_brief_description_id)
          }}
          handleMoneyOwedChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[0].asset_brief_description_id)
          }} />;
      case 1:
        return <FL142Section
          data={props.household}
          descriptionId={2}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[1].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[1].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[1].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[1].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[1].asset_brief_description_id)
          }}
          handleMoneyOwedChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[1].asset_brief_description_id)
          }} />;
      case 2:
        return <FL142Section
          data={props.jewelary}
          descriptionId={3}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[2].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[2].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[2].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[2].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[2].asset_brief_description_id)
          }}
          handleMoneyOwedChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[2].asset_brief_description_id)
          }} />;
      case 3:
        return <FL142Section
          data={props.vehicles}
          descriptionId={4}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[3].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[3].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[3].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[3].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[3].asset_brief_description_id)
          }}
          handleMoneyOwedChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[3].asset_brief_description_id)
          }} />;
      case 4:
        return <FL142Section
          data={props.savings}
          descriptionId={5}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[4].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[4].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[4].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[4].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[4].asset_brief_description_id)
          }}
          handleMoneyOwedChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[4].asset_brief_description_id)
          }} />;
      case 5:
        return <FL142Section
          data={props.checking}
          descriptionId={6}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[5].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[5].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[5].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[5].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[5].asset_brief_description_id)
          }}
          handleMoneyOwedChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[5].asset_brief_description_id)
          }} />;
      case 6:
        return <FL142Section
          data={props.credit}
          descriptionId={7}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[6].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[6].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[6].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[6].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[6].asset_brief_description_id)
          }}
          handleMoneyOwedChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[6].asset_brief_description_id)
          }} />;
      case 7:
        return <FL142Section
          data={props.cash}
          descriptionId={8}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[7].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[7].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[7].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[7].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[7].asset_brief_description_id)
          }}
          handleMoneyOwedChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[7].asset_brief_description_id)
          }} />;
      case 8:
        return <FL142Section
          data={props.taxRefund}
          descriptionId={9}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[8].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[8].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[8].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[8].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[8].asset_brief_description_id)
          }}
          handleMoneyOwedChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[8].asset_brief_description_id)
          }} />;
      case 9:
        return <FL142Section
          data={props.lifeInsurance}
          descriptionId={10}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[9].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[9].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[9].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[9].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[9].asset_brief_description_id)
          }}
          handleMoneyOwedChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[9].asset_brief_description_id)
          }} />;
      case 10:
        return <FL142Section
          data={props.stocks}
          descriptionId={11}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[10].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[10].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[10].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[10].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[10].asset_brief_description_id)
          }}
          handleMoneyOwedChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[10].asset_brief_description_id)
          }} />;
      case 11:
        return <FL142Section
          data={props.retirements}
          descriptionId={12}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[11].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[11].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[11].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[11].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[11].asset_brief_description_id)
          }}
          handleMoneyOwedChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[11].asset_brief_description_id)
          }} />;
      case 12:
        return <FL142Section
          data={props.profit}
          descriptionId={13}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[12].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[12].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[12].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[12].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[12].asset_brief_description_id)
          }}
          handleMoneyOwedChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[12].asset_brief_description_id)
          }} />;
      case 13:
        return <FL142Section
          data={props.accounts}
          descriptionId={14}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[13].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[13].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[13].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[13].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[13].asset_brief_description_id)
          }}
          handleMoneyOwedChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[13].asset_brief_description_id)
          }} />;
      case 14:
        return <FL142Section
          data={props.partnership}
          descriptionId={15}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[14].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[14].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[14].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[14].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[14].asset_brief_description_id)
          }}
          handleMoneyOwedChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[14].asset_brief_description_id)
          }} />;
      case 15:
        return <FL142Section
          data={props.otherAssets}
          descriptionId={16}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[15].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[15].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[15].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[15].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[15].asset_brief_description_id)
          }}
          handleMoneyOwedChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[15].asset_brief_description_id)
          }} />;
      
      case 16:
        return <FL142SecondSection
          data={props.studentLoans}
          descriptionId={17}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[17].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[17].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[17].asset_brief_description_id)
          }}
          handleTotalOwingChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[17].asset_brief_description_id)
          }}
          handleDateIncurredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[17].asset_brief_description_id)
          }} />;
      case 17:
        return <FL142SecondSection
          data={props.taxes}
          descriptionId={18}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[18].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[18].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[18].asset_brief_description_id)
          }}
          handleTotalOwingChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[18].asset_brief_description_id)
          }}
          handleDateIncurredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[18].asset_brief_description_id)
          }} />;
      case 18:
        return <FL142SecondSection
          data={props.support}
          descriptionId={19}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[19].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[19].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[19].asset_brief_description_id)
          }}
          handleTotalOwingChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[19].asset_brief_description_id)
          }}
          handleDateIncurredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[19].asset_brief_description_id)
          }} />;
      case 19:
        return <FL142SecondSection
          data={props.loans}
          descriptionId={20}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[20].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[20].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[20].asset_brief_description_id)
          }}
          handleTotalOwingChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[20].asset_brief_description_id)
          }}
          handleDateIncurredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[20].asset_brief_description_id)
          }} />;
      case 20:
        return <FL142SecondSection
          data={props.creditCards}
          descriptionId={21}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[21].asset_brief_description_id)
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[21].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[21].asset_brief_description_id)
          }}
          handleTotalOwingChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[21].asset_brief_description_id)
          }}
          handleDateIncurredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[21].asset_brief_description_id)
          }} />;
      case 21:
        return <FL142SecondSection
          data={props.debts}
          descriptionId={22}
          addField={(e)=>{
            setData(e);
            setDescriptionID(props.descriptionOption[22].asset_brief_description_id);
          }}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[22].asset_brief_description_id)
          }}
          handleSeparatePropertyChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[22].asset_brief_description_id)
          }}
          handleTotalOwingChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[22].asset_brief_description_id)
          }}
          handleDateIncurredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOption[22].asset_brief_description_id)
          }} />;
    
      default:
        return;
    }

  }

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    if (activeStep < 16) {
      if (!isEmpty(data)) {
        let dataWithKeys = data.map(v => ({ ...v, divorce_id: window.localStorage.getItem("divorce_id"), assetBriefDescriptionId: descriptionID }))
        props.postData({
          divorce_id: window.localStorage.getItem("divorce_id"),
          assetBriefDescriptionId: descriptionID,
          data: dataWithKeys,
        });
        setData('');
      }
    }
    else {
      if (!isEmpty(data)) {
        let dataWithKeys = data.map(v => ({ ...v, divorce_id: window.localStorage.getItem("divorce_id"), assetBriefDescriptionId: descriptionID }))
        props.postSecondTableData({
          divorce_id: window.localStorage.getItem("divorce_id"),
          assetBriefDescriptionId: descriptionID,
          data: dataWithKeys,
        });
        setData('');
      }
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const validDataPartOne = () => {
    return data.every(item => 
      item.asset_description != "" && item.asset_description != null &&
      item.asset_sep_prop != "" && item.asset_sep_prop != null && item.asset_sep_prop != "-1" && item.asset_sep_prop != "-- select an option --" &&
      item.asset_date_acquired != "" && item.asset_date_acquired != null && item.asset_date_acquired != "1947-01-01"
    );
  };
  const validDataPartTwo = () => {
    return data.every(item => 
      item.debt_description != "" && item.debt_description != null &&
      item.debt_sep_prop != "" && item.debt_sep_prop != null && item.debt_sep_prop != "-1" &&
      item.debt_date_incurred != "" && item.debt_date_incurred != null && item.debt_date_incurred != "1947-01-01"
    );
  };

  const conditionOfDisabled = () => {
    if (!isEmpty(data) && data.length === 1 && activeStep < 16 && data[0].asset_description == "" && data[0].asset_sep_prop == "" && (data[0].asset_date_acquired == "" || data[0].asset_date_acquired == "1947-01-01")) {
      return false;
    } else if (!isEmpty(data) && data.length === 1 && activeStep >= 16 && data[0].debt_description == "" && data[0].debt_sep_prop == "" && (data[0].debt_date_incurred == "" || data[0].debt_date_incurred == "1947-01-01")) {
      return false;
    } else if (!isEmpty(data) && activeStep < 16 && !validDataPartOne()) {
      return true;
    } else if (!isEmpty(data) && activeStep >= 16 && !validDataPartTwo()){
      return true;
    }
    return false;
  }

  return (
    <div className={classes.root}>
      {props.isFetchingFL142GetData ?
        <div style={{ marginLeft: "42%", marginTop: "18%" }}>
          <Loader
            type="Puff"
            color="#00BFFF"
            height={120}
            width={120}
          />
        </div>
        :
        <div>
          <Stepper activeStep={activeStep} orientation="vertical"
            style={{
              fontStyle: "normal",
              fontFamily: "sans-serif",
              backgroundColor: "white",
              textAlign: "justify",
              textJustify: "inter-word",
              padding: "30px 70px"
            }}
          >
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
                <StepContent>
                  <Typography>{getStepContent(index, props)}</Typography>
                  <div className={classes.actionsContainer}>
                    <div>
                      <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        className={classes.button}
                      >
                        Back
                      </Button>
                      <Button
                        disabled={conditionOfDisabled()}
                        variant="contained"
                        color="primary"
                        onClick={handleNext}
                        className={classes.button}
                      >
                        {activeStep === steps.length - 1 ? "Finish" : "Next"}
                      </Button>
                    </div>
                  </div>
                </StepContent>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length && (
            <Paper square elevation={0} className={classes.resetContainer}>
              <Typography>All steps completed - you&apos;re finished</Typography>
              <div>
                <Button style={{ backgroundColor: "red", color: "white" }} onClick={handleReset} className={classes.button}>
                  Reset
                </Button>
                <Button style={{ backgroundColor: "#3f51b5", color: "white" }} onClick={handleBack} className={classes.button}>
                  Back
                </Button>
              </div>
            </Paper>
          )}
          <Button
            style={{ float: "right" }}
            variant="contained"
            color="primary"
            onClick={myFunction}
          >
            Print Form
          </Button>
        </div>}
      <Modal isOpen={show} style={{ marginTop: "200px", marginLeft: "46%" }}>
        <ModalHeader>
          Important:
        </ModalHeader>
        <ModalBody> You must answer each prompt, including whether the asset or debt is
          separate property, the date, gross value and amount owed. If there is
          no value or amount owed, put in $0.0. If you don't know the date,
          put your best estimate. Otherwise, you may have trouble with the program
          transferring your information to the sheet.
          <br />
          <br />
          Use the +/- to add or delete items. If you do not have the options to add more, the court form has run out
          of space. You will need to add a separate attachment. Watch your video
          tutorials for more details.
        </ModalBody>
        <ModalFooter>
          <Row style={{ marginLeft: "3px" }}>
            <Button
              style={{ width: "48%", marginRight: "2px", color: "white", backgroundColor: "Blue" }}
              onClick={handleClose}
            >
              OK
            </Button>
          </Row>
        </ModalFooter>
      </Modal>
    </div>
  );
}
const mapDispatchToProps = (dispatch) => {
  return {
    getProfileFormData: (data) => dispatch(getProfileFormData(data)),
    postData: (data) => dispatch(postData(data)),
    successDescriptionOptionData: () => dispatch(successDescriptionOptionData()),
    postSecondTableData: (data) => dispatch(postSecondTableData(data)),
    getData: (data) => dispatch(getData(data)),
    getStates: () => dispatch(getStates()),

  };
};
const mapStateToProps = (state, ownProps) => ({
  petitioner: state.ProfileInformationReducer.petitionerDetails,
  respondent: state.ProfileInformationReducer.respondentDetails,
  court: state.ProfileInformationReducer.court,
  descriptionOption: state.fl142Reducer.descriptionOption,
  realEstate: state.fl142Reducer.realEstate,
  household: state.fl142Reducer.household,
  jewelary: state.fl142Reducer.jewelary,
  vehicles: state.fl142Reducer.vehicles,
  savings: state.fl142Reducer.savings,
  checking: state.fl142Reducer.checking,
  credit: state.fl142Reducer.credit,
  cash: state.fl142Reducer.cash,
  taxRefund: state.fl142Reducer.taxRefund,
  lifeInsurance: state.fl142Reducer.lifeInsurance,
  stocks: state.fl142Reducer.stocks,
  retirements: state.fl142Reducer.retirements,
  profit: state.fl142Reducer.profit,
  accounts: state.fl142Reducer.accounts,
  partnership: state.fl142Reducer.partnership,
  otherAssets: state.fl142Reducer.otherAssets,
  continuationAssets: state.fl142Reducer.continuationAssets,
  studentLoans: state.fl142Reducer.studentLoans,
  taxes: state.fl142Reducer.taxes,
  support: state.fl142Reducer.support,
  loans: state.fl142Reducer.loans,
  creditCards: state.fl142Reducer.creditCards,
  debts: state.fl142Reducer.debts,
  continuationDebts: state.fl142Reducer.continuationDebts,
  getData: state.fl142Reducer.getData,
  isFetchingFL142GetData: state.fl142Reducer.isFetchingFL142GetData,
  petitionerCheck: state.ProfileInformationReducer.petitionerCheck,
  states: state.ProfileInformationReducer.states,


});

export default connect(mapStateToProps, mapDispatchToProps)(FL142);